var KEY_UP_TIMEOUT = 1000;

var timerPostCodeKeyUp = false,
    zipFound = true, //
    zipFocused = false,
    currentFormId,
    selectedProduct;


function showBillingAddress() {
    $('#billing-box').removeClass('hidden-billing');
    if ($('#Contact0StreetAddress1').val() == 'auto') {
        $('#Contact0StreetAddress1').val('');
    }
    $('.card_section .badge').html('3');
    $('.pledge_section .badge').html('4');

    var tabindex = 7;
    $.each(['#Contact0StreetAddress1', '#Contact0StreetAddress2', '#Contact0Country',
        '#Contact0City', '#Contact0State', '#CreditCard0CardNumber', '#CreditCard0ExpirationMonth',
        '#CreditCard0ExpirationYear', '#CreditCard0VerificationCode'], function (key, inputId) {

        $(inputId).attr('tabindex', tabindex++);
    });
    //update tabindexes for items
}

function GetCardType(number) {
    // visa
    var re = new RegExp("^4");
    if (number.match(re) != null)
        return "Visa";

    // Mastercard
    // Updated for Mastercard 2017 BINs expansion
    if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number))
        return "MasterCard";

    // AMEX
    re = new RegExp("^3[47]");
    if (number.match(re) != null)
        return "American Express";

    // Discover
    re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
    if (number.match(re) != null)
        return "Discover";


    return "";
}

function toggleSection($ul, $link, $sign) {
    if ($ul.hasClass('hidden-xs')) {
        $ul.removeClass('hidden-xs');
        $link.html('(hide details)');
        $sign.html('&minus;');
    } else {
        $ul.addClass('hidden-xs');
        $link.html('(view details)');
        $sign.html('+');
    }
}

module.exports = {
    init: function (options) {
        $('.showdetails').click(function (e) {
            e.preventDefault();
            var $ul = $(this).parents(".optional_block").find("ul"),
                $link = $(this),
                $sign = $(this).parents('.optional_block').find('.plus-minus-sign');
            toggleSection($ul, $link, $sign);
        });

        $('.plus-minus-sign').click(function () {
            var $ul = $(this).parents(".optional_block").find("ul"),
                $link = $(this).parents(".optional_block").find('.showdetails'),
                $sign = $(this);
            toggleSection($ul, $link, $sign)
        });

        $("#Checkbox0").click(function () {
            $(this).parents("div.checkbox_container").toggleClass("checked");
        });


        // validation
        $.validator.addMethod("cardNumIsOk", function (value, element) {
            return this.optional(element) || (GetCardType(value) != 0);
        }, "Invalid card number");

		/*
		$.validator.addMethod("phoneUS", function(phone_number, element) {
			phone_number = phone_number.replace(/\s+/g, "");
			return this.optional(element) || phone_number.length > 9 && phone_number.match(/^(\+?1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/);
		}, "Please specify a valid phone number"),
		*/


		if (typeof options.checkPhoneNum !== 'undefined' && options.checkPhoneNum !== null && options.checkPhoneNum === false) {
			phoneRule = {
				required: options.PhoneRequired,
				minlength : 10
				/*,
				messages: {
					minlength: jQuery.validator.format("Please enter at least {0} numerals")
					maxlength: jQuery.validator.format("Please enter no more than {0} numerals")
				}*/				
				
			}
		}
		else {
			phoneRule = {
				required: options.PhoneRequired,
				minlength : 10,
                maxlength : 10,
                digits: true/*,
				messages: {
					minlength: jQuery.validator.format("Please enter at least {0} numerals")
					maxlength: jQuery.validator.format("Please enter no more than {0} numerals")
				}*/
			}
		}
		
		
        $(options.formId).validate({
            rules: {
                'Contact0StreetAddress1': {
                    required: true
                },
                'Contact0City': {
                    required: true
                },
                'Contact0State': {
                    required: true
                },

                'Contact0FirstName': {
                    required: true
                },
                'Contact0LastName': {
                    required: true
                },
                'Contact0Email': {
                    required: true,
                    email: true
                },
                'Contact0PostalCode': {
                    required: true
                },
                'Contact0Password': {
                    required: true,
                    minlength : 6
                },
                'conformbox': {
                    required: true
                },
                'CreditCard0CardNumber': {
                    required: true,
                    cardNumIsOk: true
                },
                'Contact0Phone1': phoneRule,
                'CreditCard0VerificationCode':{
                    required: true
                },
                'CreditCard0ExpirationMonth':{
                    required: true
                },
                'CreditCard0ExpirationYear':{
                    required: true
                }
            },
			messages: {
				'Contact0Phone1': {
					minlength: "Please enter at least 10 numerals",
					maxlength: "Please enter no more than 10 numerals"
				}
			},
            submitHandler: function (form) {
			
                $("#Order").attr('disabled', 'disabled');
				$("#submit_checkbox").hide();
				$("#submit_spinner").show();
				
				var ddd={
                        'email': $("#Contact0Email").val(),
                        'firstName': $("#Contact0FirstName").val(),
                        'pass': $("#Contact0Password").val(),
						'pro': $("#Checkbox0").is(':checked'),
                        'sid': options.sessionId,
						'form_name': $("#infusion_name").val(),
						'form_id': $("#form_id").val(),
						'price': $("#PurchasePrice").val()
						
                    };
					
				//console.log(ddd);
				
                $.ajax({
                    type: 'post',
                    url: '/tools/secure.php',
                    dataType: 'json',
                    data: ddd
                }).done(function () {
                    form.submit();
                });
				
				
            }
        });
		

        //hint
        $("#helpimg").mouseover(function () {
            $('#cvchint').css('display','none');
            $('#cvchint').removeClass('cvchinthidden');
            $('#cvchint').fadeIn();
        });
		
        $("#helpimg").mouseout(function () {
            $('#cvchint').fadeOut(function () {
                $('#cvchint').addClass('cvchinthidden');
            });
        });

        $("#Contact0PostalCode").focus(function () {
            zipFocused = true;
        });

        $("#Contact0PostalCode").blur(function () {
            zipFocused = false;
            if (!zipFound) {
                showBillingAddress();
            }
        });

        $("#Contact0PostalCode").keyup(function () {
            var zip = $(this).val(),
                self = this;

            if (zip.length > 2) {
                if (timerPostCodeKeyUp) {
                    clearTimeout(timerPostCodeKeyUp); //clear old interval
                }
                zipFound = true; //lets thing that it is ok until did not check
                timerPostCodeKeyUp = setTimeout(function () {
                    timerPostCodeKeyUp = false;
                    var zip = $(self).val();
                    var country = $("#Contact0Country").val();

                    var data = "zip=" + zip + "&country=" + country;
                    $.ajax({
                        url     : '/tools/databyzip.php',
                        type    : 'post',
                        data    : data,
                        dataType: 'json',
                        success : function (response) {
                            zipFound = true;
                            $("#Contact0City").val(response.city);
                            $("#Contact0State").val(response.state);
                            $("#citystate input").removeClass('errorfield');
                            $("#citystate").show();
                            if ($("#Contact0StreetAddress1").val()=='') {
                                $("#Contact0StreetAddress1").val("auto");
                            }

                        },
                        error : function () {
                            zipFound = false;
                            if (!zipFocused) {
                                showBillingAddress();
                            }
                        }
                    });
                }, KEY_UP_TIMEOUT);
            }
        });


        $("#CreditCard0CardNumber").on("keyup blur", function () {
            var num=$(this).val();
            var card_type = GetCardType(num);

            if (card_type !== "") {

                $("#CreditCard0CardType").val(card_type);
                // hilight selected type
                $(".cardimg").addClass("img_gr");

                if (card_type == "Visa") {
                    $("#visa").removeClass("img_gr");
                } else if (card_type == "MasterCard") {
                    $("#mastercard").removeClass("img_gr");
                } else if (card_type == "American Express") {
                    $("#amex").removeClass("img_gr");
                } else if (card_type == "Discover") {
                    $("#discover").removeClass("img_gr");
                }
            } else {
                $(".cardimg").removeClass("img_gr");
            }
        });
		
		


		/*
        $('#Order').mouseenter(function () {
            $('#Order img').prop('src', '/images/checkout/CCA-button.gif');
        }).mouseleave(function () {
            $('#Order img').prop('src', '/images/checkout/CCA-button-default.png');
        })
		*/
    },
    getFormId: function () {
        return currentFormId;
    },
    setFormId: function (formId) {
        currentFormId = formId;
    }	

};